"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _vectors = _interopRequireDefault(require("../../vectors"));

var _Badge = require("./Badge.styles");

var Badge = function Badge(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      theme = _ref.theme;

  if (theme.badges && !theme.badges.includes(name)) {
    return null;
  }

  if (size === 'auto') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _vectors["default"])({
      name: name
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_Badge.StyledBadgeContainer, {
    size: size
  }, (0, _vectors["default"])({
    name: name
  }));
};

Badge.defaultProps = {
  size: 'normal'
};
Badge.propTypes = {
  /** Name of the Badge to be added */
  name: _propTypes.string.isRequired,

  /** Size of the badge. 'auto' will adapt itself to the size of the parent container */
  size: (0, _propTypes.oneOf)(['x-small', 'small', 'normal', 'large', 'x-large', 'auto']),

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired
};
Badge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Badge",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Size of the badge. 'auto' will adapt itself to the size of the parent container",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'x-small'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }, {
          "value": "'x-large'",
          "computed": false
        }, {
          "value": "'auto'",
          "computed": false
        }]
      },
      "required": false
    },
    "name": {
      "description": "Name of the Badge to be added",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Badge);

exports["default"] = _default;